module.exports = __webpack_public_path__ + "static/media/blue.9de535a8.png";